<i18n>
{
  "fr": {
    "language-prompt": "Langue du questionnaire",
    "language-fr": "Français",
    "language-en": "Anglais"
  },
  "en": {
    "language-prompt": "Show questionnaire in",
    "language-fr": "French",
    "language-en": "English"
  }
}
</i18n>
<template>
  <div class="language-switch">
    <span class="mr-2 has-text-right is-size-7 language-switch__label" v-html="$t('language-prompt')"></span>
    <b-select
      :value="currentQuestionnaireLanguage"
      @input="(x) => $emit('update:currentQuestionnaireLanguage', x)"
      size="is-small"
    >
      <option v-for="option in languageOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
    </b-select>
  </div>
</template>
<script>
import { CONTENT_LANGUAGE_ENGLISH, CONTENT_LANGUAGE_FRENCH } from '@/consts/enums'

export default {
  props: {
    currentQuestionnaireLanguage: String
  },
  computed: {
    languageOptions() {
      return [
        { value: CONTENT_LANGUAGE_FRENCH, label: this.$t('language-fr') },
        { value: CONTENT_LANGUAGE_ENGLISH, label: this.$t('language-en') }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.language-switch {
  align-items: center;
  display: flex;
}
</style>